export default class UserModel {
  email: string;
  cmsId: number;
  firstname: string;
  middlename: string;
  lastname: string;
  companyname: string;
  isDealer: boolean;
  isEnterprise: boolean;
  hasDealerSpecialOptions: boolean;

  constructor(user: UserModel) {
    this.email = user.email;
    this.cmsId = user.cmsId;
    this.firstname = user.firstname;
    this.middlename = user.middlename;
    this.lastname = user.lastname;
    this.companyname = user.companyname;
    this.isDealer = user.isDealer;
    this.isEnterprise = user.isEnterprise;
    this.hasDealerSpecialOptions = user.hasDealerSpecialOptions;
  }
}
